<div (clickOutside)="closeSubmenu()">
    <div *ngIf="topNavigationService.getStudyNavRight()">
        <ul class="right-nav-bar">
            <li>
                <div class="rightNavBar-icons" [ngClass]="{'show-active' : isSupportMenuClicked}">
                    <a class="right-navBar-anchor-decor" role="button" aria-haspopup="true" aria-expanded="false" tabindex="0" id="appToolbarBtninfo"
                        title="Contact Support Team" aria-label="Info" (click)="loadSubMenu($event)">
                        <div class="right-nav-bar-items">
                            <i class="fas fa-envelope"></i>
                            <span class="email-text">SUPPORT</span>
                        </div>
                    </a>
                </div>
                <div class="top-sub-menu" id="infoDiv" *ngIf="isSupportMenuClicked">
                    <div class="menu-heading">Support</div>
                    <ul class="admin__nav">
                        <li *ngIf="!isClientManager && isSignInDone"><a [href]="studySetupEmailStrings" title="{{studySetupHelpText}}">Study Setup Help</a></li>
                        <ng-container *ngIf="hasAdminAccess">
                            <li><a (click)="openServiceNowSupport()" title="{{technicalSupportHelpText}}" >Technical Support</a></li>
                        </ng-container>
                        <ng-container *ngIf="hasAdminAccess === false">
                            <li *ngIf="isSignInDone" ><a (click)="openSupportMailSignInDone()" title="{{technicalSupportHelpText}}" >Technical Support</a></li>
                            <li *ngIf="!isSignInDone"><a (click)="openSupportMail()">Technical Support</a></li>
                        </ng-container>
                    </ul>
                </div>
            </li>
            <li>
                <div class="rightNavBar-icons" *ngIf="isSignInDone" [ngClass]="{'show-active' : isInfoMenuClicked}">
                    <a class="" role="button" aria-haspopup="true" aria-expanded="false" tabindex="0" id="appToolbarBtninfo"
                        title="Help" aria-label="Info" (click)="loadSubMenu($event)">
                        <div class="right-nav-bar-items">
                            <i class="fas fa-question-circle"></i>
                            <span class="email-text">HELP</span>
                        </div>

                    </a>
                </div>
                <div class="top-sub-menu" id="infoDiv" *ngIf="isInfoMenuClicked">
                    <div class="menu-heading">RCN Help</div>
                    <ul class="admin__nav">
                        <li *ngIf="!isRcnSurveyApp" (click)="openHelpInfo()"><a>Product Guide</a></li>
                        <li (click)="openMFAguideInfo()"><a>MFA Guide</a></li>
                        <li *ngIf="hasAdminAccess" (click)="downloadReleaseHistory()"><a>Release History</a></li>
                        <!-- <li routerLink="/admin/user"><a>What's New</a></li> -->
                        <!-- <li routerLink="/admin/master-activities"><a>Contact Support Team</a></li>  -->
                    </ul>
                </div>
            </li>
            <li *ngIf="!(topNavigationService.getIsClientUser() || topNavigationService.getIsClientManager() || topNavigationService.getIsClientAdmin()) && !isRcnSurveyApp && isSignInDone">
                <div class="rightNavBar-icons" [ngClass]="{'show-active' : isAdminMenuClicked}">
                    <a role="button" aria-haspopup="true" aria-expanded="false" tabindex="0" id="appToolbarBtnadminMenu"
                        title="Settings" aria-label="Admin" (click)="loadSubMenu($event)">
                        <div class="right-nav-bar-items" >
                            <i class="fas fa-cog"></i>
                            <span class="email-text">SETTINGS</span>
                        </div>
                    </a>
                </div>
                <div class="top-sub-menu" *ngIf="isAdminMenuClicked">
                    <div class="menu-heading">Admin Settings</div>
                    <ul class="admin__nav">
                        <!-- <li routerLink="/admin/admin-client-user"><a>{{manageClientText}}</a></li> -->
                        <li *ngIf="hasAdminAccess" routerLink="/admin/user"><a>Manage KPMG Users</a></li>
                        <li *ngIf="isChampion" routerLink="/admin/master-activities"><a>Manage Master Activities</a></li>
                        <li *ngIf="isChampion" routerLink="/admin/download-reports"><a>Admin Reports</a></li>
                        <li *ngIf="isChampion" routerLink="/admin/release-update"><a>Release Updates</a></li>
                        <li routerLink="/admin/action-logs">Action Logs</li>
                    </ul>
                </div>
            </li>
            <li id="user-container" class="circle-profile-icon" *ngIf="isSignInDone">
                <a class="profile-icon" role="button" aria-haspopup="true" aria-expanded="false" tabindex="0"
                    id="appToolbarUserMenu" title="User Menu" aria-label="User Menu" (click)="loadSubMenu($event)"><i
                        class="fa-user fas"></i></a>
                <div class="top-sub-menu" [ngClass]="{
                        hidden: !isProfileMenuClicked
                }">
                    <user-menu></user-menu>
                </div>
            </li>
        </ul>
    </div>
</div>
